import React from "react";

import Balloon from "../Others/balloon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const CardNote = (props) => {
    return (
        <div className="card">
            <div id="noteCard" className="row">
                <div className="col-lg-4 pt-5">
                    <Balloon color={props.colorIcon} icon={props.icon} />
                </div>
                <div className="col-lg-8">
                    <h4>{props.title}
                        {props.isBeta && <small><b> beta</b></small>}
                    </h4>
                    <div>
                        <FontAwesomeIcon icon={faArrowRight} className={"icon-" + props.colorIcon} />
                        <span className="card-text pl-1">{props.children}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

CardNote.defaultProps = {
    colorIcon: "blue"
}

export default (CardNote);